<div class="forbidden-container">
  <h1>403 - Session expired or access denied</h1>
  <p class="forbidden-message">
    Your session may be outdated or you do not have permission to view this page.
    Please sign in again to continue.
  </p>

  <div class="user-card" *ngIf="userName || userEmail || userRole">
    <p class="user-card-title">Currently signed in as</p>
    <p class="user-name" *ngIf="userName">{{ userName }}</p>
    <p class="user-email" *ngIf="userEmail">{{ userEmail }}</p>
    <p class="user-role" *ngIf="userRole">Role: {{ userRole }}</p>
  </div>

  <button class="btn btn-primary login-btn" (click)="login()">Log in again</button>
</div>
